import React from "react"
import { context } from "./context"

/**
 * Get brand context for the app
 */
export const useBrand = () => React.useContext(context)
